export const apiUrl = "https://hashfish.herokuapp.com";
// export const apiUrl = "http://localhost:5000";
export const API_BASE_URL = "https://hashfish.herokuapp.com/api/";
// export const API_BASE_URL = "http://localhost:5000/api/";

export const getApiUrl = (endpoint) => API_BASE_URL + endpoint;

export const LOGIN = getApiUrl("users/login");
export const REGISTER = getApiUrl("users/register");
export const GOOGLE_LOGIN = getApiUrl("users/googlelogin");
export const SAVE_SEARCH = getApiUrl("search/create");
